(function () {
  'use strict';

  function initCategoryStrip() {
    document.querySelectorAll('.ffc-category-strip__viewport').forEach(function (viewport) {
      if (viewport.dataset.ffcCategoryStripReady === 'true') return;
      viewport.dataset.ffcCategoryStripReady = 'true';
      viewport.addEventListener('focusin', function (event) {
        var link = event.target.closest('.ffc-category-strip__links a');
        if (!link || !viewport.contains(link)) return;
        requestAnimationFrame(function () {
          if (document.activeElement !== link) return;
          var linkBounds = link.getBoundingClientRect();
          var viewportBounds = viewport.getBoundingClientRect();
          var padding = 12;
          if (linkBounds.left < viewportBounds.left + padding) {
            viewport.scrollLeft += linkBounds.left - viewportBounds.left - padding;
          } else if (linkBounds.right > viewportBounds.right - padding) {
            viewport.scrollLeft += linkBounds.right - viewportBounds.right + padding;
          }
        });
      });
    });
  }

  initCategoryStrip();
  document.addEventListener('shopify:section:load', initCategoryStrip);
})();
